<template>
    <button class="cz2__two_pack_selector__button">
        <red-banner-button
            as="div"
            class="cz2__btn--two-pack-red-banner"
        >
            <span v-html="priceCopy" />
        </red-banner-button>

        <div
            aria-hidden="true"
            :style="{ backgroundImage: `url('${packImage}')` }"
            class="cz2__two_pack_selector__content__image-container"
        />

        <h1
            class="cz2__two_pack_selector__button-heading cz2__font-inter-black"
        >
            {{ $t('BRAND_SPLASH_HEADING') }}
        </h1>
        <ul
            v-html="$t('BRAND_SPLASH_LIST')"
            class="cz2__two_pack_selector__button-copy"
        />

        <btn
            as="span"
            class="cz2__btn--narrow cz2__btn--primary"
        >
            <span>
                {{ ctaCopy }}
            </span>
            <img
                src="../assets/images/branded/pokemon/chevron-right.svg"
                width="14"
                height="14"
            >
        </btn>

        <div class="cz2__disclaimers-wrapper">
            <p class="cz2__pickup-copy">
                <img
                    src="../assets/images/branded/pokemon/pickup-icon.svg"
                    alt=""
                    width="32"
                    height="32">
                {{ $t('BRAND_PICKUP_DISCLAIMER') }}
            </p>
            <!-- <p>
                {{ $t('BRAND_QUANTITY_DISCLAIMER') }}
            </p> -->
            <!-- <brand-copyright /> -->
        </div>
    </button>
</template>

<script>
    import RedBannerButton from './RedBannerButton.vue';
    import Btn from './ui/Btn.vue';
    // import BrandCopyright from './ui/BrandCopyright.vue';

    export default {
        name: 'TwoPackSelectorCard',

        components: {
            RedBannerButton,
            Btn,
            // BrandCopyright,
        },

        props: {
            packImage: {
                type: String,
                default: '',
            },

            bannerCopy: {
                type: String,
                default: '',
            },

            contentCopy: {
                type: String,
                default: '',
            },

            priceCopy: {
                type: String,
                default: '',
            },

            ctaCopy: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__two_pack_selector__button {
            position: relative;

            border-radius: 48px;
            padding: 24px;
            padding-bottom: 20px;
            background: color(pokemonBlue);

            display: flex;
            flex-direction: column;
            align-items: center;

            width: 100%;
            height: 100%;

            @include respond-above(md) {
                height: auto;

                .cz2__two_pack_selector__content__image-container {
                    // max-height: 260px;
                    min-height: 260px;
                }
            }

            .cz2__two_pack_selector__button-heading {
                width: 100%;
                font-weight: 900;
                font-style: italic;
                font-size: 28px;
                text-transform: uppercase;
                text-align: left;
                color: white;
            }

            .cz2__two_pack_selector__button-copy {
                padding: 0 8px;
                font-size: 15px;
                text-align: left;
                color: white;
                line-height: 19px;
                list-style-type: disc;
                margin-top: 8px;
                margin-bottom: 16px;
                margin-left: -16px;
                align-self: flex-start;
            }

            @include respond-below(sm) {
                .cz2__two_pack_selector__button-copy {
                    margin-left: 12px;
                }
            }

            .cz2__disclaimers-wrapper {
                margin-top: 16px;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 16px;
                color: white;
            }

            .cz2__pickup-copy {
                align-self: flex-start;
                color: white;
                width: 100%;
                display: flex;
                align-items: center;
                // justify-content: center;
                gap: 8px;
                font-size: 15px;
            }

            .cz2__pickup-disclaimer {
                margin-top: -6px;
                color: white;
                text-align: center;
                font-size: 10px;
            }

            .cz2__copyright {
                position: static;
            }

            .cz2__two_pack_selector__button-price {
                margin-top: 8px;
            }

            .cz2__btn--primary {
                margin-top: 8px;

                width: 100%;
                height: 40px;

                font-size: 16px;

                display: flex;
                gap: 2px;

                &.cz2__btn--narrow:hover {
                    font-size: 19px;
                }
            }

            &:focus-visible {
                outline: none;
                border: 2px solid #1E5A99;
            }
        }

        .cz2__two_pack_selector__content__image-container {
            margin-bottom: 12px;
            flex: 1 0%;
            width: 100%;

            background-color: transparent;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }

        .cz2__btn--two-pack-red-banner {
            margin-bottom: 8px;
            filter: none;
            font-size: 18px;
            line-height: 33px;
            letter-spacing: 0;

            width: fit-content;
            padding: 0 16px 0 10px;
        }

        @include respond-above(md) {
            .cz2__two_pack_selector__button-li {
                padding: 0;
            }

            .cz2__two_pack_selector__button {
                padding: 32px;
                // width: 452px;
                width: 100%;
                height: 100%;
                max-height: 706px;

                .cz2__two_pack_selector__button-copy {
                    padding: 0 40px;
                }

                .cz2__btn--secondary {
                    margin-top: 16px;

                    font-size: 18px;
                    height: 48px;

                    &.cz2__btn--narrow:hover {
                        font-size: 21px;
                    }
                }
            }

            .cz2__two_pack_selector__content__image-container {
                margin-bottom: 24px;
                // height: 260px;
            }

            .cz2__btn--two-pack-red-banner {
                font-size: 27px;
                line-height: 41px;
            }
        }

        @include respond-above(md) {
            .cz2__btn--two-pack-red-banner {
                margin-bottom: 10px;
            }

            .cz2__two_pack_selector__button {
                // width: 452px;
                max-width: 578px;
            }
        }

        @include respond-above(xl) {
            .cz2__two_pack_selector__button {
                // width: calc(100% - 600px);
                height: calc(100% - 600px);
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__two_pack_selector__button {
            width: 678px;
            height: auto;
            aspect-ratio: 452 / 502;

            .cz2__two_pack_selector__content__image-container {
            }

            .cz2__two_pack_selector__button-copy {
                font-size: 28px;
            }

            .cz2__btn--secondary {
                height: 80px;
                font-size: 40px;

                &.cz2__btn--narrow:hover {
                    font-size: 44px;
                }
            }
        }

        .cz2__btn--two-pack-red-banner {
            font-size: 80px;
            line-height: normal;
        }
    }
</style>
